import React from 'react';
import { DisplayInputComponentProps } from '../../types';
import type { FieldValues } from 'react-hook-form';
import { commonComponentsRegistry } from '../../../registry/CommonRegistry';

export const InputDate = <TFieldValues extends FieldValues>(props: DisplayInputComponentProps<TFieldValues>) => {
    const InputDate = commonComponentsRegistry.getLazyComponent('InputDate');
    return (
        <InputDate
            label={props.label}
            description={props.description || ''}
            name={props.name}
            control={props.control}
            rules={{ required: props.mandatory }}
            margin={props.margin}
        />
    );
};

export const SearchDate = <TFieldValues extends FieldValues>(props: DisplayInputComponentProps<TFieldValues>) => {
    const InputDate = commonComponentsRegistry.getLazyComponent('InputDate');
    return (
        <>
            <InputDate
                label={props.label + ' min'}
                description={props.description || ''}
                name={`${props.name}.start` as any}
                control={props.control}
                margin={props.margin}
            />
            <InputDate
                label={props.label + ' max'}
                description={props.description || ''}
                name={`${props.name}.end` as any}
                control={props.control}
                margin={props.margin}
            />
        </>
    );
};
